import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import StickyScroll from 'vuestic-ui/src/components/vuestic-directives/StickyScroll'
import { colorArray } from 'vuestic-ui/src/components/vuestic-components/va-color-picker/VuesticTheme'

export {
  VuesticPlugin,
  StickyScroll,
  colorArray,
}
